import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-center justify-center transition-fast-in-fast-out justify-center primary bg-black v-card--reveal display-3 white--text",
  style: {"height":"100%","cursor":"pointer"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createBlock(_component_v_card_text, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "text-h5 mb-0" }, "Logo", -1)),
              _withDirectives(_createVNode(_component_v_file_input, {
                accept: "image/png,image/jpg",
                ref: "logo",
                id: "companyLogo",
                "onUpdate:modelValue": _ctx.fileLogoChange
              }, null, 8, ["onUpdate:modelValue"]), [
                [_vShow, false]
              ])
            ]),
            _: 1
          }),
          (_ctx.invoiceSettings.logo)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12",
                class: "d-flex justify-center"
              }, {
                default: _withCtx(() => [
                  (_ctx.invoiceSettings.logo.signedUrl)
                    ? (_openBlock(), _createBlock(_component_v_hover, { key: 0 }, {
                        default: _withCtx(({ isHovering, props }) => [
                          _createVNode(_component_v_img, _mergeProps(props, {
                            src: _ctx.invoiceSettings.logo.signedUrl,
                            style: {"width":"100%","max-width":"200px","cursor":"pointer"},
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLogoInput()))
                          }), {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expand_transition, null, {
                                default: _withCtx(() => [
                                  isHovering
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                        _createVNode(_component_v_icon, { size: "x-large" }, {
                                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                                            _createTextVNode("$edit")
                                          ])),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1040, ["src"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: "12",
            class: "d-flex justify-center pt-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                elevation: "0",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLogoInput())),
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.invoiceSettings.logo ? "Modifier" : "Ajouter") + " le logo de la société ", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}